import { render, staticRenderFns } from "./TranslationIndex.vue?vue&type=template&id=f6ec6710&scoped=true&"
import script from "./TranslationIndex.vue?vue&type=script&lang=js&"
export * from "./TranslationIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ec6710",
  null
  
)

export default component.exports